export const sanityConfig = {
  projectId: '84grt6hk',
  apiVersion: '1',
  useCdn: false,
  dataset: import.meta.env.VITE_SANITY_DATASET as string,
}
